import type WorkflowStepView from '@UI/Store/OrganizationWorkflows/Views/WorkflowStepView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The documents of one stage: they run in parallel, and the stage runs after the previous one.
 */
class WorkflowStageView {
	readonly stage: number;
	readonly steps: readonly WorkflowStepView[];

	constructor(stage: number, steps: readonly WorkflowStepView[]) {
		this.stage = stage;
		this.steps = steps;

		Object.freeze(this);
	}

	get stageNumber(): number {
		return this.stage + 1;
	}
}

export default WorkflowStageView;
